
import React, { ReactChild } from 'react';
import { createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';

export interface IBasicPageProps {
    title: string,
    subtitle: string,
    children: ReactChild,
    dialogs?: JSX.Element|JSX.Element[]
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        backgroundColor: theme.palette.primary.light,
        padding: theme.spacing(3),
        maxWidth: '1152px',
        marginTop: 0,
    },
    titleContainer: {
        marginBottom: theme.spacing(3)
    }
}));

export function BasicPage({title, subtitle, children, dialogs}: IBasicPageProps) {
    const classes = useStyles();

    const getTitleAndSubtitle = () => {
        return (
            <Grid
                container
                spacing={1}
                className={classes.titleContainer}
            >
                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="h4">
                        {title}
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="body1">
                        {subtitle}
                    </Typography>
                </Grid>
            </Grid>
        );
    };

    return(
        <Grid container justify="center" alignItems="center">
            <Grid
                container
                direction="column"
                alignItems="stretch"
                justify="center"
                className={classes.root}>

                { (title.length > 0 || subtitle.length > 0 ) && getTitleAndSubtitle() }

                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start"
                >
                    { children }
                </Grid>
            </Grid>
            { dialogs ? dialogs : null }
        </Grid>
    );
}